import { Theme } from '@mui/material/styles'

import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'

//import { mode } from 'template/material-theme'

const useStyles = makeStyles((theme: Theme) => createStyles({

  carouselWrapper: {
    position: 'relative',
    userSelect: 'none',

    width: '100%',
    maxWidth: 'calc(100vw - 32px)', // TODO: Wo kommen die 32px her?

    [theme.breakpoints.up('sm')]: {
      maxWidth: 'calc(100vw - 75px)', // TODO: Wo kommen die 75px her?
    },

    '& .swiper': {
      '& .swiper-button-prev, & .swiper-button-next': {
        '&:after': {
          color: theme.palette.primary.light,
        },
      },
    },
  },

  nativeGallery: {
    display: 'flex',
    width: '100%',
    overflowX: 'auto',
    overflowY: 'hidden',
    scrollSnapType: 'x mandatory',
    overscrollBehaviorX: 'contain',
    scrollbarWidth: 'none',
    marginBottom: theme.spacing(4),
    '&::-webkit-scrollbar': { display: 'none' },
    '&:focus-visible': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: -2 },
    '& picture': { display: 'flex', width: '100%', height: '100%', alignItems: 'center', justifyContent: 'center' },
    '& picture img': { display: 'block', width: '100%', height: '100%', objectFit: 'contain' },
  },

  nativeSlide: {
    position: 'relative',
    flex: '0 0 100%',
    minWidth: 0,
    height: '100%',
    scrollSnapAlign: 'start',
  },

  imageButton: {
    position: 'relative',
    display: 'block',
    width: '100%',
    height: '100%',
    padding: 0,
    border: 0,
    background: 'transparent',
    cursor: 'zoom-in',
    '&:focus-visible': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: -2 },
  },

  nativeNavigation: { display: 'flex', alignItems: 'center', gap: theme.spacing(1), minWidth: 0 },
  nativeThumbnails: {
    position: 'relative', display: 'flex', gap: 10, overflowX: 'auto', minWidth: 0,
    overscrollBehaviorX: 'contain', scrollbarWidth: 'thin',
  },
  nativeThumbnail: {
    position: 'relative', flex: '0 0 100px', width: 100, height: 70,
    boxSizing: 'border-box', padding: 0, overflow: 'hidden',
    border: `1px solid ${theme.palette.text.primary}`, background: '#fff', cursor: 'pointer',
    '&[aria-pressed="true"]': { borderWidth: 2 },
    '&:focus-visible': { outline: `2px solid ${theme.palette.primary.main}`, outlineOffset: -3 },
    '& img': { display: 'block', width: '100%', height: '100%', objectFit: 'contain' },
  },
  galleryArrow: {
    flex: '0 0 30px', width: 30, height: 44, padding: 0, border: 0,
    fontSize: 32, lineHeight: 1, color: theme.palette.primary.main,
    background: 'transparent', cursor: 'pointer',
    '&:disabled': { opacity: .35, cursor: 'default' },
    '&:focus-visible': { outline: `2px solid ${theme.palette.primary.main}` },
  },

  imageSwiper: {
    height: '450px',
    marginBottom: theme.spacing(4),

    /*...(darkMode ? {
      backgroundColor: 'white',
      borderRadius: '14px',
    }:{}),*/

    '& .swiper-slide, & .swiper-zoom-container': {
      cursor: 'pointer',
      '& > picture': {
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      },
      '& > img, & > picture > img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
      },
    },
  },

  imageSwiperModalOnly: {
    touchAction: 'pan-y',

    '& .swiper-slide, & .swiper-zoom-container': {
      touchAction: 'pan-y',
    },
  },

  imageSlide: {
    position: 'relative',
  },

  thumbnailSlide: {
    position: 'relative',
  },

  thumbs: {
    '& .swiper-slide': {
      boxSizing: 'border-box',
      width: '100px',
      height: '70px',
      maxHeight: '70px',
      overflow: 'hidden',
      border: '1px solid',
      borderColor: theme.palette.text.primary,
      cursor: 'pointer',

      /*...(darkMode ? {
        backgroundColor: 'white',
        borderRadius: '9px',
      }:{}),*/

      '& > img': {
        width: '100%',
        height: '100%',
        objectFit: 'contain',
        backgroundColor: '#fff',
      },

      '&:hover': {
        border: '2px solid',
        padding: 2,
      },
    },

    '& .swiper-slide-thumb-active': {
      border: '2px solid',
    },
  },

}))

export default useStyles
